import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Components
import TestimonialBox from "../Elements/TestimonialBox";

export default function TestimonialSlider() {
  const settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 3, // 3 columns
    slidesToScroll: 3, // scroll 3 at a time (next "page" of 6)
    rows: 2, // 2 rows
    slidesPerRow: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          rows: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 2,
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...settings}>
        <LogoWrapper>
          <TestimonialBox
            text="Booking my appointment was a breeze with this AI agent. It understood my needs and confirmed everything instantly!"
            author="Priya S."
          />
        </LogoWrapper>
        <LogoWrapper>
          <TestimonialBox
            text="I love how quickly the AI scheduled my meeting without any hassle. It even suggested the best available slots for me."
            author="Rahul M."
          />
        </LogoWrapper>
        <LogoWrapper>
          <TestimonialBox
            text="No more waiting on hold or back-and-forth emails. The AI handled my appointment smoothly and sent me a confirmation right away."
            author="Anjali T."
          />
        </LogoWrapper>
        <LogoWrapper>
          <TestimonialBox
            text="This AI agent is a real time-saver! It was efficient, accurate, and made the whole process stress-free."
            author="Karan P."
          />
        </LogoWrapper>
        <LogoWrapper>
          <TestimonialBox
            text="I was amazed at how easy it was to book through the AI. It even reminded me about my appointment the day before!"
            author="Sneha R."
          />
        </LogoWrapper>
        <LogoWrapper>
          <TestimonialBox
            text="Great experience from start to finish. The AI agent took care of everything and kept me updated throughout."
            author="Amit J."
          />
        </LogoWrapper>
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 95%;
  padding: 0 2.5%;
  box-sizing: border-box;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
